<template>

<div class="message" :class="{'is-error': error, 'is-success': success}">

	<app-icon :name="icon" />

	<div class="message-content">

		<slot></slot>

	</div>

</div>

</template>

<script>

export default {

	props: ['error', 'success'],

	computed: {

		icon: function() {

			if (this.error) return 'error'

			return 'success'

		}

	}

}

</script>

<style scoped>

.message {
	border-radius: 4px;
	padding: 10px;
	display: flex;
	flex-direction: row;
}

.message.is-error {
	background-color: var(--color-red-light);
}

.message.is-success {
	background-color: var(--color-green-light);
}

.message .icon {
	margin-top: 4px;
	margin-right: 10px;
	margin-bottom: 4px;
	font-size: 32px;
}

.message.is-error .icon {
	color: var(--color-red-dark);
}

.message.is-success .icon {
	color: var(--color-green-dark);
}

.message-content {
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 14px;
    line-height: 20px;
    font-weight: 700;
}

.message.is-error .message-content {
	color: var(--color-red-dark);
}

.message.is-success .message-content {
	color: var(--color-green-dark);
}

</style>